(function () {
  const COLLECTION_DISCOUNT_RULES = [
    { collectionHandle: 'collaboration-all-collections', code: 'KNOT20' },
  ];

  const STORAGE_KEY = 'auto_discount_code';
  const STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  let isApplying = false;
  let hasQueuedRun = false;

  function readStoredCode() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const stored = JSON.parse(raw);
      if (!stored || !stored.code || !stored.expiresAt || stored.expiresAt < Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return stored.code;
    } catch (error) {
      return null;
    }
  }

  function storeCode(code) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ code: code, expiresAt: Date.now() + STORAGE_TTL_MS })
      );
    } catch (error) {
      /* storage unavailable */
    }
  }

  function clearStoredCode() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* storage unavailable */
    }
  }

  function codeFromCurrentUrl() {
    const paramCode = new URLSearchParams(window.location.search).get('discount');
    if (paramCode) return paramCode.trim();

    const path = window.location.pathname;

    const discountPathMatch = path.match(/\/discount\/([^/?#]+)/);
    if (discountPathMatch) return decodeURIComponent(discountPathMatch[1]);

    const matchedRule = COLLECTION_DISCOUNT_RULES.find(function (rule) {
      return new RegExp('/collections/' + rule.collectionHandle + '(?:/|$)').test(path);
    });

    return matchedRule ? matchedRule.code : null;
  }

  function matchesCode(discountCode, code) {
    return discountCode.code.toLowerCase() === code.toLowerCase();
  }

  function cartHasCode(cart, code) {
    return (cart.discount_codes || []).some(function (discountCode) {
      return matchesCode(discountCode, code);
    });
  }

  function cartHasOtherApplicableCode(cart, code) {
    return (cart.discount_codes || []).some(function (discountCode) {
      return discountCode.applicable && !matchesCode(discountCode, code);
    });
  }

  function localeUrl(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  async function readCartJson(response) {
    if (!response.ok) return null;

    const text = await response.text();
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  async function getCart() {
    return readCartJson(await fetch(localeUrl('/cart.js'), { headers: { Accept: 'application/json' } }));
  }

  async function applyStoredCodeToCart() {
    const code = readStoredCode();
    if (!code) return;

    if (isApplying) {
      hasQueuedRun = true;
      return;
    }

    isApplying = true;

    try {
      const cart = await getCart();
      if (!cart || !cart.item_count) return;
      if (cartHasCode(cart, code)) return;
      if (cartHasOtherApplicableCode(cart, code)) return;

      const updatedCart = await readCartJson(
        await fetch(localeUrl('/cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        })
      );
      if (!updatedCart || !cartHasCode(updatedCart, code)) return;

      if (typeof window.refreshCartDrawerSection === 'function') {
        await window.refreshCartDrawerSection();
      }
    } catch (error) {
      console.error('Auto discount could not be applied:', error);
    } finally {
      isApplying = false;
      if (hasQueuedRun) {
        hasQueuedRun = false;
        applyStoredCodeToCart();
      }
    }
  }

  async function forgetCodeIfShopperRemovedIt() {
    try {
      const cart = await getCart();
      if (cart && cart.item_count > 0) {
        clearStoredCode();
      }
    } catch (error) {
      /* leave the stored code in place */
    }
  }

  function requestBodyRemovesDiscount(init) {
    if (!init || typeof init.body !== 'string') return false;

    try {
      const body = JSON.parse(init.body);
      return Object.prototype.hasOwnProperty.call(body, 'discount') && body.discount === '';
    } catch (error) {
      return false;
    }
  }

  function watchCartMutations() {
    const originalFetch = window.fetch;

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartMutation = !isApplying && CART_MUTATION_PATTERN.test(url);
      const isDiscountRemoval = isCartMutation && requestBodyRemovesDiscount(init);

      const request = originalFetch.apply(this, arguments);
      if (!isCartMutation) return request;

      return request.then(function (response) {
        if (response.ok) {
          setTimeout(isDiscountRemoval ? forgetCodeIfShopperRemovedIt : applyStoredCodeToCart, 0);
        }
        return response;
      });
    };
  }

  const codeForThisVisit = codeFromCurrentUrl();
  if (codeForThisVisit) {
    storeCode(codeForThisVisit);
  }

  window.autoDiscount = {
    hasPendingCode: function () {
      return Boolean(readStoredCode());
    },
  };

  watchCartMutations();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStoredCodeToCart);
  } else {
    applyStoredCodeToCart();
  }
})();
